import React from 'react';

export default function IconBE() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#464655"
                d="M10.461 21.462H.541A.546.546 0 0 1 0 20.91V1.089C0 .785.242.54.541.54h9.92v20.923Z"
            />
            <path fill="#FFE15A" d="M20.923.538H10.462v20.924h10.461V.538Z" />
            <path
                fill="#FF4B55"
                d="M31.459 21.462h-9.92V.538h9.92c.299 0 .541.247.541.551v19.822c0 .304-.242.55-.541.55Z"
            />
        </svg>
    );
}
